import { memo } from "react";

import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { SUBJECT_LABELS } from "../../../../1_BSZFinderApp/components/sectionCards/werHilftSection/config/subjectConfig";

import { ROW_HEIGHT, LABEL_WIDTH } from "../constants/timelineConstants";

import { getSubjectColor } from "../utils/timelineUtils";

import TimelineRowLabel from "./TimelineRowLabel";
import TimelineRowCells from "./TimelineRowCells";

function TimelineRow({ row, weeks, holidayWeeks, dialogs, type }) {
  const theme = useTheme();

  const label = row.label ?? SUBJECT_LABELS[row.subjectName] ?? row.subjectName;

  const color = getSubjectColor(row.subjectName, theme);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: ROW_HEIGHT,
      }}
    >
      <TimelineRowLabel
        label={label}
        width={type === "teacherOwnProjectView" ? 120 : LABEL_WIDTH}
      />

      <TimelineRowCells
        row={row}
        weeks={weeks}
        holidayWeeks={holidayWeeks}
        color={color}
        dialogs={dialogs}
      />
    </Box>
  );
}

export default memo(TimelineRow);
